import { isArray } from 'lodash';
import { EMPTY_PLAN_REASON } from '../../consts/defaultPlanReason';

export const serializePlanReason = reason => ({
  id: reason.id && String(reason.id),
  title: reason.title,
  isActive: reason.is_active,
});

export const serializePlanReasons = reasons => {
  if (!isArray(reasons) && reasons.length < 1) return null;

  const serializedReasons = reasons.map(reason => serializePlanReason(reason));
  return [EMPTY_PLAN_REASON, ...(serializedReasons || [])];
};
